<div class="debtor-search-component-wrapper">
  @if (isModal) {
    <app-modal-header [title]="title" [close]="onCancelClick" [hideClose]="requireSelection">
    </app-modal-header>
  }
  <div class="grid" [ngClass]="{'grid-container' : isModal}">
    <div class="search-or-preview">
      @if (!preview) {
        <div class="search-input-container">
          <app-shared-custom-search
            [searchAll]="searchString"
            [placeholder]="'Search Debtors'"
            (searchChange)="searchOnKeyUp($event)">
          </app-shared-custom-search>
        </div>
      } @else {
      <h1>
        Selected Debtors
      </h1>
    }
    </div>

    <div [ngClass]="isModal? 'modal-grid-div' : 'grid-div'">
      <ag-grid-angular
        (gridReady)="onGridReady($event)"
        (gridSizeChanged)="onGridSizeChange()"
        [columnDefs]="gridColDefs"
        [loading]="isLoading"
        [gridOptions]="getGridOptions"
        [overlayNoRowsTemplate]="overlayTemplate"
        [rowData]="fuzzyDebtors"
        [theme]="'legacy'"
        class="ag-theme-custom">
      </ag-grid-angular>
    </div>
  </div>
  @if (isModal) {
    <app-shared-modal-footer>
      <div class="buttons-div">
        <app-shared-button (buttonClicked)="onViewSelectedClick()" [disabled]="selectedStockItemCount < 1 && !preview"
                           [fill]="false">
          {{ getPreviewButtonData }}
        </app-shared-button>
        <app-shared-button (buttonClicked)="onGetSelectedStockItemsClick()" [disabled]="selectedStockItemCount < 1"
                           [fill]="false">
          Select {{ selectedStockItemCount }} {{ selectedStockItemCount === 1 ? 'Debtor' : 'Debtors' }}
        </app-shared-button>
      </div>
    </app-shared-modal-footer>
  }
</div>
